import { LockIcon } from "@chakra-ui/icons";
import { Badge, Flex, Icon, Text } from "@chakra-ui/react";
import { TableViewReadData } from "gen/model/tableViewReadData";
import { FaGlobe } from "react-icons/fa6";

export const PermBadge: React.FC<{ view: TableViewReadData }> = ({ view }) => {
  const { copy, colorScheme, icon } = view.visible_to
    ? {
        copy: "Private",
        colorScheme: "dark_gray" as const,
        icon: (
          <LockIcon width="10px" height="10px" position="relative" top="-1px" />
        ),
      }
    : {
        copy: "Public",
        colorScheme: "blue" as const,
        icon: <Icon as={FaGlobe} width="10px" height="10px" />,
      };
  return (
    <Badge
      colorScheme={colorScheme}
      display="flex"
      alignItems="center"
      justifyContent="center"
      columnGap="4px"
      height="20px"
    >
      <Flex alignItems="center" justifyContent="center" columnGap="4px">
        {icon}
        <Text>{copy}</Text>
      </Flex>
    </Badge>
  );
};
